module.exports = __webpack_public_path__ + "img/trainingDetails.13b5ea16.png";